module.exports = __webpack_public_path__ + "static/images/leaflet-measure/trash_@2X.png";